import axios from './axiosConfig';
import NotificationService from './NotificationService';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://api.local.dev:8080'}/api/shop`;

class MediaService {
  static async uploadFile(file, type = 'image', { alt = '', fileName } = {}) {
    if (!(file instanceof Blob)) {
      throw new Error('Fichier invalide pour l\'upload');
    }

    const formData = new FormData();
    const resolvedName = fileName || file?.name || (type === 'video' ? 'video.mp4' : 'image.jpg');

    formData.append('file', file, resolvedName);
    formData.append('type', type);
    formData.append('alt', alt);
    if (file?.type) {
      formData.append('mimeType', file.type);
    }

    try {
      const response = await axios.post(`${API_URL}/media/upload`, formData, {
        transformRequest: [(data, headers) => {
          delete headers['Content-Type'];
          return data;
        }],
      });

      return response.data.data;
    } catch (error) {
      const apiMessage = error.response?.data?.error;
      NotificationService.error(apiMessage || 'Erreur lors de l\'upload du média');
      console.error('Error uploading media:', error.response?.data || error);
      throw error;
    }
  }
}

export default MediaService;
